import { Statement } from "@motleyhand/design"

export default function Craftsmanship() {
  return (
    <section className="mx-auto max-w-140 px-6 pt-5 pb-10 sm:pt-10 sm:pb-20">
      <Statement sub="Complex underneath, simple on the outside, obsessively built for people who care about their craft.">
        The juggler makes impossible coordination look effortless.
        {/* The break is deliberate: it splits the line where the sentence does,
            rather than wherever the measure happens to run out. Only above the
            small breakpoint, where there is room for two balanced lines. */}
        <br className="hidden sm:inline" /> That&apos;s what good tools do.
      </Statement>
    </section>
  )
}
